import { memo } from 'react';
import PropTypes from 'prop-types';


const BzTextArea = ({ rows, cols, className, inputRef, ...props }) => {
  return (
    <textarea className={className} rows={rows} cols={cols} ref={inputRef} {...props}>
    </textarea>
  )
}

export default memo(BzTextArea)

BzTextArea.propTypes = {
  className: PropTypes.string,
  rows: PropTypes.number,
  cols: PropTypes.number,
}

BzTextArea.defaultProps = {
  rows: 5
}